import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, useParams } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import App from './app/app';
import store, { persistor } from './app/common/store/store';
import { MatomoProviderGate } from './app/common/providers/matomo-provider-gate';

// When embedded in an iframe, never let programmatic focus scroll the host page.
// reactjs-popup (and other libs) call element.focus() without { preventScroll: true },
// which makes the browser scroll the parent page to bring the iframe into view on load
// (e.g. the landing modal focusing its first focusable element). Force preventScroll
// for all focus calls while embedded so the host page stays put.
if (window.self !== window.top) {
  const nativeFocus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function (options?: FocusOptions) {
    nativeFocus.call(this, { ...options, preventScroll: true });
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate
        loading={null}
        persistor={persistor}>
        <BrowserRouter>
          <MatomoProviderGate>
            <App />
          </MatomoProviderGate>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </StrictMode>
);
